import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_SALES_ORDERS_REQUEST = 'GET_SALES_ORDERS_REQUEST';
export const GET_SALES_ORDERS_SUCCESS = 'GET_SALES_ORDERS_SUCCESS';
export const GET_SALES_ORDERS_ERROR = 'GET_SALES_ORDERS_ERROR';

export const GET_SALES_ORDER_REQUEST = 'GET_SALES_ORDER_REQUEST';
export const GET_SALES_ORDER_SUCCESS = 'GET_SALES_ORDER_SUCCESS';
export const GET_SALES_ORDER_ERROR = 'GET_SALES_ORDER_ERROR';

export const CREATE_SALES_ORDER_REQUEST = 'CREATE_SALES_ORDER_REQUEST';
export const CREATE_SALES_ORDER_SUCCESS = 'CREATE_SALES_ORDER_SUCCESS';
export const CREATE_SALES_ORDER_ERROR = 'CREATE_SALES_ORDER_ERROR';

export const UPDATE_SALES_ORDER_REQUEST = 'UPDATE_SALES_ORDER_REQUEST';
export const UPDATE_SALES_ORDER_SUCCESS = 'UPDATE_SALES_ORDER_SUCCESS';
export const UPDATE_SALES_ORDER_ERROR = 'UPDATE_SALES_ORDER_ERROR';

export const CHANGE_STATUS_SALES_ORDER_REQUEST = 'CHANGE_STATUS_SALES_ORDER_REQUEST';
export const CHANGE_STATUS_SALES_ORDER_SUCCESS = 'CHANGE_STATUS_SALES_ORDER_SUCCESS';
export const CHANGE_STATUS_SALES_ORDER_ERROR = 'CHANGE_STATUS_SALES_ORDER_ERROR';

export const UPLOAD_SALES_ORDER_FILES_REQUEST = 'UPLOAD_SALES_ORDER_FILES_REQUEST';
export const UPLOAD_SALES_ORDER_FILES_PROGRESS = 'UPLOAD_SALES_ORDER_FILES_PROGRESS';
export const UPLOAD_SALES_ORDER_FILES_SUCCESS = 'UPLOAD_SALES_ORDER_FILES_SUCCESS';
export const UPLOAD_SALES_ORDER_FILES_ERROR = 'UPLOAD_SALES_ORDER_FILES_ERROR';

export const DELETE_SALES_ORDER_FILE_REQUEST = 'DELETE_SALES_ORDER_FILE_REQUEST';
export const DELETE_SALES_ORDER_FILE_SUCCESS = 'DELETE_SALES_ORDER_FILE_SUCCESS';
export const DELETE_SALES_ORDER_FILE_ERROR = 'DELETE_SALES_ORDER_FILE_ERROR';

export const DELETE_SALES_ORDER_REQUEST = 'DELETE_SALES_ORDER_REQUEST';
export const DELETE_SALES_ORDER_SUCCESS = 'DELETE_SALES_ORDER_SUCCESS';
export const DELETE_SALES_ORDER_ERROR = 'DELETE_SALES_ORDER_ERROR';

export const CLEAN_SALES_ORDERS = 'CLEAN_SALES_ORDERS';

// Get salesOrders
export function getSalesOrders(query) {
    return async (dispatch) => {
        try {
            dispatch(getSalesOrdersRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/sales-orders/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSalesOrdersSuccess, getSalesOrdersError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSalesOrdersError));
        }
    };
}
function getSalesOrdersRequest() {
    return {
        type: GET_SALES_ORDERS_REQUEST,
        isFetching: true
    };
}
function getSalesOrdersSuccess (payload) {
    return {
        type: GET_SALES_ORDERS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSalesOrdersError(errorMessage) {
    return {
        type: GET_SALES_ORDERS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get salesOrder
export function getSalesOrder(salesOrderId) {

    return async (dispatch) => {
        try {
            dispatch(getSalesOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/sales-orders/${salesOrderId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSalesOrderSuccess, getSalesOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSalesOrderError));
        }
    };
}
function getSalesOrderRequest() {
    return {
        type: GET_SALES_ORDER_REQUEST,
        isFetching: true
    };
}
function getSalesOrderSuccess (payload) {
    return {
        type: GET_SALES_ORDER_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSalesOrderError(errorMessage) {
    return {
        type: GET_SALES_ORDER_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create salesOrder
export function createSalesOrder(salesOrder, options) {
    return async (dispatch) => {
        try {
            dispatch(createSalesOrderRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/sales-orders', {salesOrder, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createSalesOrderSuccess, createSalesOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, createSalesOrderError));
        }
    };
}
function createSalesOrderRequest() {
    return {
        type: CREATE_SALES_ORDER_REQUEST,
        isFetching: true
    };
}
function createSalesOrderSuccess (payload) {
    return dispatch => {
        // Create notification for create salesOrder success
        dispatch(addNotification({
            message: 'Pedido añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_SALES_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createSalesOrderError(errorMessage) {
    return dispatch => {
        // Create notification for create salesOrder error
        dispatch(addNotification({
            message: 'Error al añadir el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_SALES_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update salesOrder
export function updateSalesOrder(salesOrderId, salesOrder = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateSalesOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/sales-orders/${salesOrderId}`, salesOrder, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateSalesOrderSuccess, updateSalesOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateSalesOrderError));
        }
    };
}
function updateSalesOrderRequest() {
    return {
        type: UPDATE_SALES_ORDER_REQUEST,
        isFetching: true
    };
}
function updateSalesOrderSuccess (payload) {
    return dispatch => {
        // Create notification for update salesOrder success
        dispatch(addNotification({
            message: 'Pedido actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_SALES_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateSalesOrderError(errorMessage) {
    return dispatch => {
        // Create notification for update salesOrder error
        dispatch(addNotification({
            message: 'Error al actualizar el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_SALES_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change salesOrder status
export function changeSalesOrderStatus(salesOrderId, status, options = { populateRefs: true, calculateStatistics: 'quotes', deleteVirtuals: true }) {
    return async (dispatch) => {
        try {
            dispatch(changeSalesOrderStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/sales-orders/${salesOrderId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeSalesOrderStatusSuccess, changeSalesOrderStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeSalesOrderStatusError));
        }
    };
}
function changeSalesOrderStatusRequest() {
    return {
        type: CHANGE_STATUS_SALES_ORDER_REQUEST,
        isFetching: true
    };
}
function changeSalesOrderStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_SALES_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changeSalesOrderStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_SALES_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload salesOrder files
export function uploadSalesOrderFiles(salesOrderId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadSalesOrderFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/sales-orders/${salesOrderId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadSalesOrderFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadSalesOrderFilesSuccess, uploadSalesOrderFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadSalesOrderFilesError));
        }
    };
}
function uploadSalesOrderFilesRequest() {
    return {
        type: UPLOAD_SALES_ORDER_FILES_REQUEST,
        isFetching: true
    };
}
function uploadSalesOrderFilesProgress(percent) {
    return {
        type: UPLOAD_SALES_ORDER_FILES_PROGRESS,
        percent
    };
}
function uploadSalesOrderFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload salesOrder file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_SALES_ORDER_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadSalesOrderFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload salesOrder file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_SALES_ORDER_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download salesOrder file
export function downloadSalesOrderFile(salesOrderId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/sales-orders/${salesOrderId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete salesOrder file
export function deleteSalesOrderFile(salesOrderId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteSalesOrderFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/sales-orders/${salesOrderId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSalesOrderFileSuccess, deleteSalesOrderFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSalesOrderFileError));
        }
    };
}
function deleteSalesOrderFileRequest() {
    return {
        type: DELETE_SALES_ORDER_FILE_REQUEST,
        isFetching: true
    };
}
function deleteSalesOrderFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SALES_ORDER_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteSalesOrderFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SALES_ORDER_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete salesOrder
export function deleteSalesOrder(salesOrderId) {

    return async (dispatch) => {
        try {
            dispatch(deleteSalesOrderRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/sales-orders/${salesOrderId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSalesOrderSuccess, deleteSalesOrderError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSalesOrderError));
        }
    };
}
function deleteSalesOrderRequest() {
    return {
        type: DELETE_SALES_ORDER_REQUEST,
        isFetching: true
    };
}
function deleteSalesOrderSuccess (payload) {
    return dispatch => {
        // Create notification for delete salesOrder success
        dispatch(addNotification({
            message: 'Pedido eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SALES_ORDER_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteSalesOrderError(errorMessage) {
    return dispatch => {
        // Create notification for delete salesOrder error
        dispatch(addNotification({
            message: 'Error al eliminar el pedido',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SALES_ORDER_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean salesOrders reducer
export function cleanSalesOrders() {
    return {
        type: 'CLEAN_SALES_ORDERS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/sales-orders.js